module.exports = __webpack_public_path__ + "img/user.ba88038e.svg";